/**
 * ONE Account UI API
 * Rest API definition for ONE Account UI. 
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: toannhanb7@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UserData { 
    id?: string;
    username?: string;
    lastName?: string;
    firstName?: string;
    email?: string;
    password?: string;
    preferred_username?: string;
    attributes?: object;
    access?: object;
    clientConsents?: Array<object>;
    clientRoles?: object;
    createdTimestamp?: number;
    credentials?: object;
    disableableCredentialTypes?: Array<string>;
    emailVerified?: boolean;
    enabled?: boolean;
    federatedIdentities?: Array<object>;
    federationLink?: string;
    groups?: Array<string>;
    notBefore?: number;
    origin?: string;
    realmRoles?: Array<string>;
    requiredActions?: Array<string>;
    self?: string;
    serviceAccountClientId?: string;
}

